import {PromotionType} from "../../promotion/helpers/PromotionType";
import {IBoosterBigDataType} from "../types/IBoosterBigDataType";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../types/IBoosterOfferStatsType";

export const gtmBoosterCategoryTypeMap = {
    [IBoosterCategory.OfferStats]: {
        [IBoosterOfferStatsType.Area]: "metraż",
        [IBoosterOfferStatsType.Room]: "pokoje",
        [IBoosterOfferStatsType.Garage]: "z garażem",
        [IBoosterOfferStatsType.Floor]: "piętra",
        [IBoosterOfferStatsType.Balcony]: "balkon",
        [IBoosterOfferStatsType.Terrace]: "taras",
        [IBoosterOfferStatsType.QuarterNorth]: "rozkładem na północ",
        [IBoosterOfferStatsType.QuarterSouth]: "rozkładem na południe",
        [IBoosterOfferStatsType.QuarterEast]: "rozkładem na wschód",
        [IBoosterOfferStatsType.QuarterWest]: "rozkładem na zachód"
    },
    [IBoosterCategory.BigDataStats]: {
        [IBoosterBigDataType.ViewsLast3Days]: "3 ostatnie dni",
        [IBoosterBigDataType.HasIncreasedInterest]: "wzrost zainteresowania"
    },
    [IBoosterCategory.Promotion]: {
        [PromotionType.PROMOTION]: "promocja",
        [PromotionType.OPEN_DAYS]: "dni otwarte",
        [PromotionType.DISCOUNT]: "przecena",
        [PromotionType.LAST_MINUTE]: "last minute",
        [PromotionType.PRESALE]: "przedsprzedaż",
        [PromotionType.EXHIBITION]: "targi mieszkaniowe",
        [PromotionType.NO_CONTRIBUTION]: "nieruchomość bez wkładu własnego"
    }
};

export const getBoosterCategoryTypeLabel = (category: IBoosterCategory, boosterType: IBoosterOfferStatsType | IBoosterBigDataType | IBoosterCategory) => {
    const categoryMap = gtmBoosterCategoryTypeMap[category] as Record<string, string>;

    return boosterType in categoryMap ? categoryMap[boosterType] : null;
};
import {PromotionType} from "../../promotion/helpers/PromotionType";
import {IBoosterBigDataType} from "../types/IBoosterBigDataType";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../types/IBoosterOfferStatsType";

export const gtmBoosterCategoryTypeMap = {
    [IBoosterCategory.OfferStats]: {
        [IBoosterOfferStatsType.Area]: "metraż",
        [IBoosterOfferStatsType.Room]: "pokoje",
        [IBoosterOfferStatsType.Garage]: "z garażem",
        [IBoosterOfferStatsType.Floor]: "piętra",
        [IBoosterOfferStatsType.Balcony]: "balkon",
        [IBoosterOfferStatsType.Terrace]: "taras",
        [IBoosterOfferStatsType.QuarterNorth]: "rozkładem na północ",
        [IBoosterOfferStatsType.QuarterSouth]: "rozkładem na południe",
        [IBoosterOfferStatsType.QuarterEast]: "rozkładem na wschód",
        [IBoosterOfferStatsType.QuarterWest]: "rozkładem na zachód"
    },
    [IBoosterCategory.BigDataStats]: {
        [IBoosterBigDataType.ViewsLast3Days]: "3 ostatnie dni",
        [IBoosterBigDataType.HasIncreasedInterest]: "wzrost zainteresowania"
    },
    [IBoosterCategory.Promotion]: {
        [PromotionType.PROMOTION]: "promocja",
        [PromotionType.OPEN_DAYS]: "dni otwarte",
        [PromotionType.DISCOUNT]: "przecena",
        [PromotionType.LAST_MINUTE]: "last minute",
        [PromotionType.PRESALE]: "przedsprzedaż",
        [PromotionType.EXHIBITION]: "targi mieszkaniowe",
        [PromotionType.NO_CONTRIBUTION]: "nieruchomość bez wkładu własnego"
    }
};

export const getBoosterCategoryTypeLabel = (category: IBoosterCategory, boosterType: IBoosterOfferStatsType | IBoosterBigDataType | IBoosterCategory) => {
    const categoryMap = gtmBoosterCategoryTypeMap[category] as Record<string, string>;

    return boosterType in categoryMap ? categoryMap[boosterType] : null;
};
